import Image from "next/image";
import Link from "next/link";
import React from "react";

const RelatedCard = ({ data, type }: { data: any, type: "college" | "exam" }) => {

  const linkUrl = type === "college" ?
    `/colleges/${data?.college_url}/college-info` :
    `/exams/${data?.exam_url}/exam-info`

  const title = type === "college" ? data?.college_name : data?.exam_name;

  return (
    <div className="group relative flex min-w-60 max-w-60 flex-col overflow-hidden rounded-md bg-gray-100 shadow-md transition-all duration-300 hover:shadow-xl">
      {/* Banner */}
      <Link href={linkUrl}>
        <div className="relative w-full">
          <Image
            src={data?.banner?.[0]?.url ?? ""}
            alt={title ?? "related"}
            // fill
            objectFit="fill"
            width={400}
            height={280}
            className="h-28 max-h-28 min-h-28 object-cover"
          />
          {/* Logo - over banner */}
          <div className="absolute -bottom-6 left-4 flex size-14 items-center justify-center rounded-full bg-white p-1 shadow-lg">
            <Image
              src={data?.logo?.url}
              alt={title ?? "logo"}
              width={50}
              height={50}
              className="rounded-full object-contain"
            />
          </div>
        </div>
      </Link>

      {/* Content */}
      <div className="flex flex-col gap-2 px-4 pb-4 pt-8">
        <Link href={linkUrl}>
          <p className=" font-poppins text-sm font-semibold text-gray-800 group-hover:text-blue-600">
            {title}
          </p>
          <p className="mt-1 line-clamp-2 text-xs text-gray-600">
            {`Explore more about this ${type}.`}
          </p>
        </Link>
      </div>
    </div>
  );
};

export default RelatedCard;
